import { makeStyles } from '@material-ui/core';
export default makeStyles(function () { return ({
    linkedList: {
        padding: 0,
        margin: 0,
    },
    linked: {
        '& button': {
            textDecoration: 'underline',
        },
        color: '#5565FD',
        listStyleType: 'none',
        padding: '6px 16px',
        cursor: 'pointer',
    },
    popper: {
        width: 'auto !important',
    },
}); });
